module.exports = __webpack_public_path__ + "static/media/hashtag.2c010be0.svg";